<template>
  <div>
    <router-link v-if="allowClick(link)" :to="link.route">
      <div class="icon-container d-flex justify-content-center align-items-center">
        <b-icon :icon="link.icon" class="icon" :title="link.display"></b-icon>
        <div class="active-icon" v-if="isActive(link.route)" />
      </div>
    </router-link>
    <div v-else class="icon-container d-flex justify-content-center align-items-center">
      <b-icon :icon="link.icon" class="icon" :title="link.display"></b-icon>
      <div class="active-icon" v-if="isActive(link.route)" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarIcon',
  props: ['link'],
  methods: {
    isActive(route) {
      return `/${this.$route.path.split('/')[1]}` === route
    },
    allowClick: function (link) {
      return this.$route.path !== link.route
    }
  }
}
</script>

<style scoped>
.icon-container {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  border: 2px solid white;
  position: relative;
  cursor: pointer;
}

.icon {
  width: 70%;
  height: 70%;
  color: white;
  position: absolute;
}

.active-icon {
  width: 15px;
  height: 15px;
  background-color: white;
  border-radius: 50%;
  border: 3px solid #2D3363;
  position: absolute;
  right: -4px;
  top: -4px;
}
</style>



// WEBPACK FOOTER //
// src/app/components/Layout/Sidebar/SidebarIcon.vue?1e061a6f